import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { EnquiryContext } from "./context/EnquiryState";
import { SuburbAutocomplete } from "./SuburbAutocomplete";
import { DateTime } from "luxon";

const recaptchaRef = React.createRef();

const days = [
	"Sun",
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat",
];

const monthNames = ["January", "February", "March", "April", "May", "June",
	"July", "August", "September", "October", "November", "December"
];

export const ReviewFormComponent = () => {

	const {
		state,
		dispatch,
		TrackAnalyticsEvent
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		dispatch({ type: "SET_FORM_COMPONENT", payload: "reviewForm" })

		TrackAnalyticsEvent("review")
	}, [])

	const HandleVerify = (token) => {
		let clonedForm = state.form
		clonedForm.recapResult = token
		dispatch({ type: "UPDATE_FORM", payload: clonedForm })
		CheckCanSubmit()
	}

	const CheckCanSubmit = () => {

		if (!!state.form.recapResult) {
			// If we aren't saving and have a Recaptcha then allow submit
			dispatch({ type: "SET_CAN_SUBMIT", payload: true })
		} else {
			dispatch({ type: "SET_CAN_SUBMIT", payload: false })
		}
	}

	const buildLiveTourBookingDetails = () => {
		let timeSlot: DateTime = state.form.liveTourBookingSlot

		if (timeSlot == null) {
			return
		}

		return (
			<>
				<div className="mb-3 font-semibold text-xl">Tour details</div>

				<div className="my-5 bg-skin-site-header rounded-lg p-4 flex flex-col gap-3">
					<div className="flex items-centres gap-3">
						<img src="/img/icons/calendar.svg" alt="" className="h4 w-4" />
						<p>{timeSlot.toFormat("EEEE, d MMMM yyyy")}</p>
					</div>
					<div className="flex items-centres gap-3">
						<img src="/img/icons/time.svg" alt="" className="h4 w-4" />
						<p>{timeSlot.toFormat("h:mm a")}</p>
					</div>
					<div className="flex items-centres gap-3">
						<img src="/img/icons/map-pin.svg" alt="" className="h4 w-4" />
						<p>{`${state.model.enquiryCentreDetailsList[0].centreAddress}, ${state.model.enquiryCentreDetailsList[0].centreSuburb} ${state.model.enquiryCentreDetailsList[0].centrePostcode}`}</p>
					</div>
				</div>
			</>
		)
	}

	return (
		<div>
			{state.initialSelection.id == 4 && buildLiveTourBookingDetails()}

			<div className="mb-3 font-semibold text-xl">
				Contact details
			</div>
			<div className="mb-6">
				<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
					<span className="text-xs">NAME</span>
					<span className="text-base font-bold">{state.form.parentFullName}</span>
				</div>
				<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
					<span className="text-xs">EMAIL</span>
					<span className="text-base font-bold">{state.form.email}</span>
				</div>
				<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
					<span className="text-xs">NUMBER</span>
					<span className="text-base font-bold">{state.form.contactNumber}</span>
				</div>
				{state.initialSelection.id != 4 &&
					<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
						<span className="text-xs">BEST TIME TO CALL</span>
						<span className="text-base font-bold">{state.form.bestTimeToCall}</span>
					</div>
				} 
			</div>

			{state.initialSelection.id == 2 &&
				<React.Fragment>
					<div className="mb-3 font-semibold text-xl">
						Visit details
					</div>
					<div className="w-full bg-skin-site-header rounded-3xl p-6 mb-8">

						<div className="flex flex-row items-center gap-3 mb-4">
							<img src="/img/icons/calendar-icon.svg" />
							<div>
								<span className="font-bold block">
									{state.form.days.map((day, i) => {
										let comma = ', '

										// Remove comma if its the last in the list
										if (i == state.form.days.length - 1) {
											comma = ''
										}
										return days[day] + comma
									})}
								</span>
								<span>{state.form.preferredTourTime}</span>
							</div>
						</div>

						<div className="flex flex-row items-center gap-3">
							<img src="/img/icons/pink-map-marker.svg" />
							<div>
								<span className="font-bold block">{state.model.centreAddress}</span>
								<span>{state.model.centreSuburb} {state.model.centreState} {state.model.centrePostcode}</span>
							</div>
						</div>

					</div>
					<div className="mb-3 font-semibold text-xl">
						Child details
					</div>
					{
						state.form.children.map((child, index) => {
							let childDays;

							if (child.daysRequiredList.length == 7 || child.daysRequiredList.length == 0) {
								childDays = 'Mon - Sun'
							} else {
								childDays = child.daysRequiredList.map((day, i) => {
									let comma = ', '

									// Remove comma if its the last in the list
									if (i == child.daysRequiredList.length - 1) {
										comma = ''
									}
									return days[day] + comma
								})
							}

							return <div className="mb-6 text-base font-semibold">
								<div className="text-skin-autocomplete-mark font-bold">Child {index + 1}</div>
								<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
									<span className="text-xs">DAYS</span>
									<span className="text-base font-bold">{childDays}</span>
								</div>
								<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
									<span className="text-xs">START DATE</span>
									<span className="text-base font-bold">{monthNames[child.startDate.getMonth()]} {child.startDate.getFullYear()}</span>
								</div>
								<div className="flex flex-row items-center justify-between border-b border-skin-neutral-light py-3">
									<span className="text-xs">BIRTHDAY</span>
									<span className="text-base font-bold">{monthNames[child.childsBirthday.getMonth()]} {child.childsBirthday.getFullYear()}</span>
								</div>
							</div>
						})
					}
				</React.Fragment>
			}

			{(state.form.additionalFees ||
				state.form.additionalAvailability ||
				state.form.additionalProgram ||
				state.form.additionalOther ||
				state.form.requestATour) &&
				<React.Fragment>
					{(state.form.additionalFees || state.form.additionalAvailability || state.form.additionalProgram || state.form.requestATour || state.form.additionalOther) &&
						<div>
							<div className="mb-3 font-semibold text-xl">
								Enquiry details
							</div>

							<div className="w-full bg-skin-site-header rounded-3xl p-6 mb-4 flex flex-col gap-3">
								<div className="text-sm">
									<ul className="list-disc list-inside">
										{state.form.requestATour && <li>Request a Tour</li>}
										{state.form.additionalFees && <li>Fees</li>}
										{state.form.additionalAvailability && <li>Availability</li>}
										{state.form.additionalProgram && <li>Program</li>}
									</ul>
								</div>
								{(!!state.form.additionalQuestions && state.form.additionalQuestions != "") &&
									<div className="text-sm">
										{state.form.additionalQuestions}
									</div>
								}
							</div>
						</div>
					}

				</React.Fragment>
			}

			<div className="my-10">
				<ReCAPTCHA
					ref={recaptchaRef}
					sitekey={state.model.rcap}
					onChange={token => HandleVerify(token)}
				/>
			</div>


		</div>
	);

}